import Vue from "vue";
import Router from "vue-router";
import MainLayout from "@/layout/MainLayout.vue";
import Login from "@/views/Login.vue";
import Assets from "@/views/Assets.vue";
import Episodes from "@/views/Episodes.vue";
import ImageTasks from "@/views/ImageTasks.vue";
import Users from "@/views/Users.vue";
import SystemAdmin from "@/views/SystemAdmin.vue";
import StoryPlays from "@/views/StoryPlays.vue";
import StoryPlayEdit from "@/views/StoryPlayEdit.vue";
import StoryPlayFullscreen from "@/views/StoryPlayFullscreen.vue";
import SystemSettings from "@/views/SystemSettings.vue";
import MiniGames from "@/views/MiniGames.vue";
import MiniGameLevels from "@/views/MiniGameLevels.vue";
import MiniGameResources from "@/views/MiniGameResources.vue";
import TTS from "@/views/TTS.vue";
import ThirdPartyGames from "@/views/ThirdPartyGames.vue";
import UserAnalysis from "@/views/UserAnalysis.vue";
import Leaderboard from "@/views/Leaderboard.vue";
import Levels from "@/views/Levels.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/story-plays/:id/play",
      name: "storyPlayFullscreen",
      component: StoryPlayFullscreen
    },
    {
      path: "/",
      component: MainLayout,
      redirect: "/assets",
      children: [
        {
          path: "assets",
          name: "assets",
          component: Assets
        },
        {
          path: "episodes",
          name: "episodes",
          component: Episodes
        },
        {
          path: "image-tasks",
          name: "imageTasks",
          component: ImageTasks
        },
        {
          path: "users",
          name: "users",
          component: Users
        },
        {
          path: "system",
          name: "system",
          component: SystemAdmin
        },
        {
          path: "system-settings",
          name: "systemSettings",
          component: SystemSettings
        },
        {
          path: "story-plays",
          name: "storyPlays",
          component: StoryPlays
        },
        {
          path: "story-plays/:id/edit",
          name: "storyPlayEdit",
          component: StoryPlayEdit
        },
        {
          path: "levels",
          name: "levels",
          component: Levels
        },
        {
          path: "mini-games",
          name: "miniGames",
          component: MiniGames
        },
        {
          path: "mini-games/:id/levels",
          name: "miniGameLevels",
          component: MiniGameLevels
        },
        {
          path: "tts",
          name: "tts",
          component: TTS
        },
        {
          path: "third-party-games",
          name: "thirdPartyGames",
          component: ThirdPartyGames
        },
        {
          path: "user-analysis",
          name: "userAnalysis",
          component: UserAnalysis
        },
        {
          path: "leaderboard",
          name: "leaderboard",
          component: Leaderboard
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.path !== "/login" && !token) {
    next("/login");
    return;
  }
  const adminOnly = ["/users", "/system", "/user-analysis", "/leaderboard"];
  if (token && adminOnly.includes(to.path)) {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user.role !== "admin") {
        next("/assets");
        return;
      }
    } catch (e) {
      next("/assets");
      return;
    }
  }
  next();
});

export default router;
